export class VendasKpisPeriodoModel {
  _id?: Date;
  vendasLiquidas: number;
  desconto: number;
  pecasVendidas: number;
  numeroVendas: number;
  vendedores: number;
  diasTrabalhados: number;
  cmv: number;
  compras: number;
  pecasCompradas: number;
}

export function emptyVendasKpisPeriodo(): VendasKpisPeriodoModel {
  return {
    vendasLiquidas: 0,
    desconto: 0,
    pecasVendidas: 0,
    numeroVendas: 0,
    vendedores: 0,
    diasTrabalhados: 0,
    cmv: 0,
    compras: 0,
    pecasCompradas: 0,
  };
}
